import React from "react";
import { Box, CircularProgress } from "@mui/material";

const PageLoader = ({ fullscreen = false }) => {
  return (
    <Box
      sx={{
        position: fullscreen ? "fixed" : "absolute",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "rgba(255,255,255,0.55)",
      }}
    >
      <CircularProgress />
    </Box>
  );
};

export default PageLoader;
